import _ from 'lodash';

import { talentsArmoryToSimc } from './talents';
import { find as findRealm } from './realms';
import { CLASSES, CLASS_ID_MAP } from './classes';

export const MAX_LEVEL = 60;

export const classes = CLASSES;
export const classIdMap = CLASS_ID_MAP;

export const races = [{
  id: 1,
  mask: 1,
  side: 'alliance',
  name: 'Human',
  simcName: 'human',
}, {
  id: 2,
  mask: 2,
  side: 'horde',
  name: 'Orc',
  simcName: 'orc',
}, {
  id: 3,
  mask: 4,
  side: 'alliance',
  name: 'Dwarf',
  simcName: 'dwarf',
}, {
  id: 4,
  mask: 8,
  side: 'alliance',
  name: 'Night Elf',
  simcName: 'night_elf',
}, {
  id: 5,
  mask: 16,
  side: 'horde',
  name: 'Undead',
  simcName: 'undead',
}, {
  id: 6,
  mask: 32,
  side: 'horde',
  name: 'Tauren',
  simcName: 'tauren',
}, {
  id: 7,
  mask: 64,
  side: 'alliance',
  name: 'Gnome',
  simcName: 'gnome',
}, {
  id: 8,
  mask: 128,
  side: 'horde',
  name: 'Troll',
  simcName: 'troll',
}, {
  id: 9,
  mask: 256,
  side: 'horde',
  name: 'Goblin',
  simcName: 'goblin',
}, {
  id: 10,
  mask: 512,
  side: 'horde',
  name: 'Blood Elf',
  simcName: 'blood_elf',
}, {
  id: 11,
  mask: 1024,
  side: 'alliance',
  name: 'Draenei',
  simcName: 'draenei',
}, {
  id: 22,
  mask: 2097152,
  side: 'alliance',
  name: 'Worgen',
  simcName: 'worgen',
}, {
  id: 24,
  mask: 8388608,
  side: 'neutral',
  name: 'Pandaren',
  simcName: 'pandaren',
}, {
  id: 25,
  mask: 16777216,
  side: 'alliance',
  name: 'Pandaren',
  simcName: 'pandaren_alliance',
}, {
  id: 26,
  mask: 33554432,
  side: 'horde',
  name: 'Pandaren',
  simcName: 'pandaren_horde',
}, {
  id: 27,
  mask: 0,
  side: 'horde',
  name: 'Nightborne',
  simcName: 'nightborne',
}, {
  id: 28,
  mask: 0,
  side: 'horde',
  name: 'Highmountain Tauren',
  simcName: 'highmountaintauren',
}, {
  id: 29,
  mask: 0,
  side: 'alliance',
  name: 'Void Elf',
  simcName: 'voidelf',
}, {
  id: 30,
  mask: 0,
  side: 'alliance',
  name: 'Lightforged Draenei',
  simcName: 'lightforgeddraenei',
}, {
  id: 31,
  mask: 0,
  side: 'horde',
  name: 'Zandalari Troll',
  simcName: 'zandalari_troll',
}, {
  id: 32,
  mask: 0,
  side: 'alliance',
  name: 'Kul Tiran',
  simcName: 'kul_tiran',
}, {
  id: 34,
  mask: 0,
  side: 'alliance',
  name: 'Dark Iron Dwarf',
  simcName: 'dark_iron_dwarf',
}, {
  id: 36,
  mask: 0,
  side: 'horde',
  name: 'Mag\'har Orc',
  simcName: 'magharorc',
}, {
  id: 35,
  mask: 0,
  side: 'horde',
  name: 'Vulpera',
  simcName: 'vulpera',
}, {
  id: 37,
  mask: 0,
  side: 'alliance',
  name: 'Mechagnome',
  simcName: 'mechagnome',
}];

// simc role to wow API role
export const roleMap = {
  attack: 'DPS',
  healer: 'HEALING',
  tank: 'TANK',
};

// map spec to role
export const specMap = {
  // shared
  holy: roleMap.healer,
  protection: roleMap.tank,
  frost: roleMap.attack,
  restoration: roleMap.healer,

  blood: roleMap.tank,
  unholy: roleMap.attack,

  havoc: roleMap.attack,
  vengeance: roleMap.tank,

  balance: roleMap.attack,
  feral: roleMap.attack,
  guardian: roleMap.tank,

  beast_mastery: roleMap.attack,
  marksmanship: roleMap.attack,
  survival: roleMap.attack,

  arcane: roleMap.attack,
  fire: roleMap.attack,

  brewmaster: roleMap.tank,
  mistweaver: roleMap.healer,
  windwalker: roleMap.attack,

  retribution: roleMap.attack,

  discipline: roleMap.healer,
  shadow: roleMap.attack,

  assassination: roleMap.attack,
  outlaw: roleMap.attack,
  combat: roleMap.attack,
  subtlety: roleMap.attack,

  elemental: roleMap.attack,
  enhancement: roleMap.attack,

  affliction: roleMap.attack,
  demonology: roleMap.attack,
  destruction: roleMap.attack,

  arms: roleMap.attack,
  fury: roleMap.attack,
};

export const specInfo = {
  [classIdMap['Death Knight']]: {
    blood: {
      id: 250,
      name: 'Blood',
      role: 'tank',
      mainStat: 'str',
      icon: 'spell_deathknight_bloodpresence',
    },
    frost: {
      id: 251,
      name: 'Frost',
      dualWield: true,
      role: 'melee',
      mainStat: 'str',
      icon: 'spell_deathknight_frostpresence',
    },
    unholy: {
      id: 252,
      name: 'Unholy',
      role: 'melee',
      mainStat: 'str',
      icon: 'spell_deathknight_unholypresence',
    },
  },
  [classIdMap['Demon Hunter']]: {
    havoc: {
      id: 577,
      name: 'Havoc',
      role: 'melee',
      dualWield: true,
      mainStat: 'agi',
      icon: 'ability_demonhunter_specdps',
    },
    vengeance: {
      id: 581,
      name: 'Vengeance',
      role: 'tank',
      dualWield: true,
      mainStat: 'agi',
      icon: 'ability_demonhunter_spectank',
    },
  },
  [classIdMap.Druid]: {
    balance: {
      id: 102,
      name: 'Balance',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_nature_starfall',
    },
    feral: {
      id: 103,
      name: 'Feral',
      role: 'melee',
      mainStat: 'agi',
      icon: 'ability_druid_catform',
    },
    guardian: {
      id: 104,
      name: 'Guardian',
      role: 'tank',
      mainStat: 'agi',
      icon: 'ability_racial_bearform',
    },
    restoration: {
      id: 105,
      name: 'Restoration',
      role: 'healer',
      mainStat: 'int',
      icon: 'spell_nature_healingtouch',
    },
  },
  [classIdMap.Hunter]: {
    beast_mastery: {
      id: 253,
      name: 'Beast Mastery',
      role: 'ranged',
      mainHandOnly: true,
      mainStat: 'agi',
      icon: 'ability_hunter_bestialdiscipline',
    },
    marksmanship: {
      id: 254,
      name: 'Marksmanship',
      role: 'ranged',
      mainHandOnly: true,
      mainStat: 'agi',
      icon: 'ability_hunter_focusedaim',
    },
    survival: {
      id: 255,
      name: 'Survival',
      role: 'melee',
      mainStat: 'agi',
      icon: 'ability_hunter_camouflage',
    },
  },
  [classIdMap.Mage]: {
    arcane: {
      id: 62,
      name: 'Arcane',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_holy_magicalsentry',
    },
    fire: {
      id: 63,
      name: 'Fire',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_fire_firebolt02',
    },
    frost: {
      id: 64,
      name: 'Frost',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_frost_frostbolt02',
    },
  },
  [classIdMap.Monk]: {
    brewmaster: {
      id: 268,
      name: 'Brewmaster',
      role: 'tank',
      dualWield: true,
      mainStat: 'agi',
      icon: 'spell_monk_brewmaster_spec',
      extraStatScales: ['stamina'],
    },
    mistweaver: {
      id: 270,
      name: 'Mistweaver',
      role: 'healer',
      mainStat: 'int',
      icon: 'spell_monk_mistweaver_spec',
    },
    windwalker: {
      id: 269,
      name: 'Windwalker',
      role: 'melee',
      dualWield: true,
      mainStat: 'agi',
      icon: 'spell_monk_windwalker_spec',
      extraStatScales: ['stamina'],
    },
  },
  [classIdMap.Paladin]: {
    holy: {
      id: 65,
      name: 'Holy',
      role: 'healer',
      mainStat: 'int',
      icon: 'spell_holy_holybolt',
    },
    protection: {
      id: 66,
      name: 'Protection',
      role: 'tank',
      mainStat: 'str',
      icon: 'ability_paladin_shieldofthetemplar',
    },
    retribution: {
      id: 70,
      name: 'Retribution',
      role: 'melee',
      mainStat: 'str',
      icon: 'spell_holy_auraoflight',
    },
  },
  [classIdMap.Priest]: {
    discipline: {
      id: 256,
      name: 'Discipline',
      role: 'healer',
      mainStat: 'int',
      icon: 'spell_holy_powerwordshield',
    },
    holy: {
      id: 257,
      name: 'Holy',
      role: 'healer',
      mainStat: 'int',
      icon: 'spell_holy_guardianspirit',
    },
    shadow: {
      id: 258,
      name: 'Shadow',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_shadow_shadowwordpain',
    },
  },
  [classIdMap.Rogue]: {
    assassination: {
      id: 259,
      name: 'Assassination',
      role: 'melee',
      dualWield: true,
      mainStat: 'agi',
      icon: 'ability_rogue_deadlybrew',
    },
    outlaw: {
      id: 260,
      name: 'Outlaw',
      role: 'melee',
      dualWield: true,
      mainStat: 'agi',
      icon: 'ability_rogue_waylay',
    },
    subtlety: {
      id: 261,
      name: 'Subtlety',
      role: 'melee',
      dualWield: true,
      mainStat: 'agi',
      icon: 'ability_stealth',
    },
  },
  [classIdMap.Shaman]: {
    elemental: {
      id: 262,
      name: 'Elemental',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_nature_lightning',
    },
    enhancement: {
      id: 263,
      name: 'Enhancement',
      role: 'melee',
      dualWield: true,
      mainStat: 'agi',
      icon: 'spell_shaman_improvedstormstrike',
    },
    restoration: {
      id: 264,
      name: 'Restoration',
      role: 'healer',
      mainStat: 'int',
      icon: 'spell_nature_magicimmunity',
    },
  },
  [classIdMap.Warlock]: {
    affliction: {
      id: 265,
      name: 'Affliction',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_shadow_deathcoil',
    },
    demonology: {
      id: 266,
      name: 'Demonology',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_shadow_metamorphosis',
      extraStatScales: ['stamina'],
    },
    destruction: {
      id: 267,
      name: 'Destruction',
      role: 'caster',
      mainStat: 'int',
      icon: 'spell_shadow_rainoffire',
    },
  },
  [classIdMap.Warrior]: {
    arms: {
      id: 71,
      name: 'Arms',
      role: 'melee',
      mainStat: 'str',
      icon: 'ability_warrior_savageblow',
    },
    fury: {
      id: 72,
      name: 'Fury',
      role: 'melee',
      dualWield: true,
      dualWield2h: true,
      mainStat: 'str',
      icon: 'ability_warrior_innerrage',
    },
    protection: {
      id: 73,
      name: 'Protection',
      role: 'tank',
      mainStat: 'str',
      icon: 'ability_warrior_defensivestance',
    },
  },
};

export const specs = [];
_.each(specInfo, (classSpec, classId) => {
  _.each(classSpec, (spec, key) => {
    specs.push({
      ...spec,
      class: _.find(classes, { id: parseInt(classId, 10) }),
      key,
    });
  });
});

export const specIdLookup = _.fromPairs(_.map(specs, spec => ([
  _.join([
    _.replace(_.toLower(spec.class.name), ' ', ''),
    _.replace(_.toLower(spec.name), ' ', ''),
  ], '_'),
  spec.id,
])));

export const getClassInfo = (classSearch) => {
  if (_.isNumber(classSearch)) {
    return _.find(classes, { id: classSearch });
  }
  return _.find(classes, c => {
    return _.toLower(_.camelCase(c.name)) === _.toLower(_.camelCase(classSearch));
  });
};

export const getSpecsForClass = classSearch => {
  const classInfo = getClassInfo(classSearch);
  return _.filter(specs, { class: { id: classInfo.id } });
};

export const getSpecInfoById = specId => _.find(specs, { id: specId });

// Finite cache set, should be fine for lodash memoize
export const getSpecInfo = _.memoize((classSearch, specSearch) => {
  const classInfo = getClassInfo(classSearch);
  if (classInfo) {
    let info;
    if (_.isNumber(specSearch)) {
      info = _.find(specInfo[String(classInfo.id)], { id: specSearch });
    } else {
      info = specInfo[String(classInfo.id)][_.snakeCase(specSearch)];
    }
    if (info) {
      return getSpecInfoById(info.id);
    }
  }
  return null;
}, (...args) => args.join('::'));

export const getSpecsByMainStat = mainStat => _.filter(specs, { mainStat });

export const activeTalents = (character) => {
  if (character) {
    return _.find(character.talents, { selected: true });
  }

  return null;
};

export const normalizeRegion = _.toLower;
export const normalizeRealm = realm => _.toLower(
  _.replace(
    _.replace(realm, /[ -]/g, '-'),
    /'/g,
    '',
  ),
);
export const normalizeName = _.toLower;

export const getCharacterSpecInfo = character => {
  const talents = activeTalents(character);
  const classId = _.get(character, 'class');
  const classInfo = _.find(classes, { id: classId });
  if (talents && classInfo) {
    return getSpecInfo(classInfo.name, _.get(talents, 'spec.name'));
  }
  return null;
};

export const factions = [{
  id: 0,
  name: 'alliance',
}, {
  id: 1,
  name: 'horde',
}];

export const getFaction = character => {
  if (!character) {
    return 'horde';
  }

  const faction = _.find(factions, { id: character.faction });
  if (faction) {
    return faction.name;
  }

  return 'horde';
};

export const getSpecId = character => _.get(getCharacterSpecInfo(character), 'id');

export const className = (character) => {
  if (character) {
    const classId = _.get(character, 'class');
    return _.get(_.find(classes, { id: classId }), 'name', null);
  }

  return null;
};

// add 1 to each character to get simc talents
export const armoryToSimcTalents = (character) => {
  if (character) {
    const { calcTalent } = activeTalents(character);
    return talentsArmoryToSimc(calcTalent);
  }

  return null;
};

export const getRole = character => {
  const talents = activeTalents(character);
  if (talents) {
    const spec = talents.spec;

    if (spec) {
      return spec.role;
    }
  }

  return false;
};

export const isTank = (character) => {
  return getRole(character) === 'TANK';
};

export const isHealer = (character) => {
  return getRole(character) === 'HEALING';
};

export const isUnsupportedHealer = (character) => {
  if (character) {
    const spec = _.get(activeTalents(character), 'spec');
    if (spec) {
      const supported = [{
        // MW Monk
        classId: 10,
        specName: 'Mistweaver',
      }, {
        // resto druid
        classId: 11,
        specName: 'Restoration',
      }, {
        // resto sham
        classId: 7,
        specName: 'Restoration',
      }, {
        // Holy pally
        classId: 2,
        specName: 'Holy',
      }];
      /*
      const unsupported = [{
        // holy priest
        classId: 5,
        specName: 'Holy',
      }, {
        // disc priest
        classId: 5,
        specName: 'Discipline',
      }];
      */
      const isSupported = _.find(supported, { classId: character.class, specName: spec.name });
      return (spec.role === 'HEALING' && !isSupported);
    }
  }
  return false;
};

export const isUnsupportedSpec = (character) => {
  if (character) {
    // all healers unsupported except DPS for disc
    if (isUnsupportedHealer(character)) {
      return true;
    }
    const spec = _.get(activeTalents(character), 'spec');
    if (spec) {
      const unsupported = [{
        /*
        // prot warrior
        classId: 1,
        specName: 'Protection',
        */
      }];

      return !!_.find(unsupported, { classId: character.class, specName: spec.name });
    }

    return false;
  }

  return false;
};

export const characterImage = (region, character, size = 'avatar') => {
  if (!region || !character) {
    return null;
  }
  if (!_.includes(['us', 'eu', 'tw', 'kr'], _.toLower(region))) {
    return null;
  }

  const realm = findRealm(region, character.realm);

  return `/wowapi/character/${region}/${realm.slug}/${_.toLower(character.name)}/image/${size}`;
  // return `//render-${region}.worldofwarcraft.com/character/${character.thumbnail.replace('avatar', size)}`;
};
export const avatar = (region, character) => characterImage(region, character, 'inset');

export const armoryRegionLocaleMap = {
  us: 'en_US',
  eu: 'en_GB',
  kr: 'en_US',
  tw: 'en_US',
};

export const getArmoryLink = (region, realm, name) => {
  // https://worldofwarcraft.com/en-us/character/malganis/seriallos
  const locale = armoryRegionLocaleMap[region];
  const [locRegion, locLang] = _.split(locale, '_');
  const localeSlug = `${locRegion}-${_.toLower(locLang)}`;
  return `https://worldofwarcraft.com/${localeSlug}/character/${realm}/${name}`;
};
export const getWarcraftLogsLink = (region, realm, name) => {
  // https://www.warcraftlogs.com/character/us/malganis/seriallos
  return `https://www.warcraftlogs.com/character/${region}/${realm}/${name}`;
};
export const getRaiderIoLink = (region, realm, name) => {
  // https://raider.io/characters/us/malganis/Seriallos
  return `https://raider.io/characters/${region}/${realm}/${name}`;
};

export const getCharacterLinks = (region, character) => {
  if (!region || !character) {
    return null;
  }
  const regionNormalized = normalizeRegion(region);
  const realm = _.get(findRealm(region, character.realm), 'slug');
  const name = normalizeName(character.name);
  return {
    armory: getArmoryLink(regionNormalized, realm, name),
    warcraftlogs: getWarcraftLogsLink(regionNormalized, realm, name),
    raiderio: getRaiderIoLink(regionNormalized, realm, name),
  };
};
